import { Col, Row } from "../components/Grid";
import { ContactTab } from "../components/Footer";
import ContentBlock from "../components/ContentBlock";
import HtmlContainer from "../components/HtmlContainer";
import PropTypes from "prop-types";
import React from "react";
import TextSection from "../components/TextSection";
import countriesContactInfo from "../content/countriesContactInfo";
import injectSheet from "react-jss";

const styles = theme => ({
  page: {
    height: "100vh",
    paddingTop: 0,
    marginTop: 0,
    "@media (max-width: 1499px)": {
      height: "100%",
      minHeight: "100vh"
    }
  },
  container: {
    width: "1000px",
    height: "100%",
    "@media (max-width: 823px)": {
      width: "90%"
    }
  },
  text: {
    fontSize: "1.3rem",
    fontWeight: 200,
    paddingLeft: "5rem",
    paddingRight: "5rem",
    marginTop: "1rem",
    marginBottom: "2rem",
    textAlign: "center",
    "@media (max-width: 823px)": {
      padding: 0,
      marginLeft: "1rem",
      marginRight: "1rem",
      width: "90%"
    },
    "& h1": {
      fontSize: "5.4rem",
      fontWeight: 200,
      margin: 0,
      "@media (max-width: 823px)": {
        fontSize: "3rem"
      }
    }
  },
  contactSections: {
    color: theme.colours.content.fontColor,
    textAlign: "center",
    fontSize: "1.2rem",
    margin: "1.5rem"
  },
  contactSectionsMobile: {
    color: theme.colours.content.fontColor,
    textAlign: "center",
    fontSize: "1.2rem",
    marginLeft: "1.5rem",
    marginBottom: "1rem"
  },
  contactEmail: {
    color: theme.colours.content.fontColor
  },
  noMobile: {
    "@media (max-width: 1499px)": {
      display: "none"
    }
  },
  mobile: {
    maxWidth: "90vw",
    "@media (min-width: 1500px)": {
      display: "none"
    }
  }
});

const ContactPage = ({ data, classes }) => (
  <ContentBlock className={classes.page}>
    <div className={classes.container}>
      <TextSection className={classes.text}>
        <HtmlContainer content={data.TopParagraph.html} />
      </TextSection>
      <div className={classes.noMobile}>
        <Row center>
          {countriesContactInfo.map(country => (
            <ContactTab
              key={country.name}
              name={country.name}
              phonenumber={country.phonenumber}
              email={country.email}
              supportemail={country.supportemail}
              address={country.address}
              className={classes.contactSections}
              linkstyle={classes.contactEmail}
            />
          ))}
        </Row>
      </div>
      <div className={classes.mobile}>
        <Col middle center>
          {countriesContactInfo.map(country => (
            <ContactTab
              key={country.name}
              name={country.name}
              phonenumber={country.phonenumber}
              email={country.email}
              supportemail={country.supportemail}
              address={country.address}
              className={classes.contactSectionsMobile}
              linkstyle={classes.contactEmail}
            />
          ))}
        </Col>
      </div>
    </div>
  </ContentBlock>
);

ContactPage.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object
};

export default injectSheet(styles)(ContactPage);

/* global graphql */
export const ContactQuery = graphql`
  query ContactQuery {
    TopParagraph: markdownRemark(frontmatter: { name: { eq: "Contact" } }) {
      html
      frontmatter {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx